import * as gfunctions from '../../../js/generalFunctions';

CCL.orderConfirmation = {
  autoload: [
    ['expectToggle', $('.expectation').length > 0]
  ],

  expectToggle() {
    $('.expectation').each((index, element) => {
      const Prodtitle = $(element).find('.what-to-expect-title').data('prodtitle');
      const descObj = $(element).children('.upsellProduct-description');
      gfunctions.seeMoreLess(descObj, Prodtitle);
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-order-confirmation/order-confirmation.js